import { Capacitor } from '@capacitor/core'

const storageKey = 'lastVisible'
let visibleInterval

export default {
  methods: {
    async handleVisibilityChange () {
      if (document.visibilityState === 'hidden') {
        this.stopVisibleTimer()
      } else {
        this.stopVisibleTimer()
        const lastVisible = await this.getLastVisible()
        if (Date.now() >= (+lastVisible + (1000 * 60 * 5)) && Capacitor.isNativePlatform()) {
          await location.reload()
        }
        await this.startVisibleTimer()
      }
    },

    async setLastVisible () {
      await this.$storage.set({
        key: storageKey,
        value: Date.now().toString()
      })
    },

    async getLastVisible () {
      const res = await this.$storage.get({
        key: storageKey
      })

      return res.value
    },

    async startVisibleTimer () {
      await this.setLastVisible()
      visibleInterval = setInterval(this.setLastVisible, 1000 * 60)
    },

    stopVisibleTimer () {
      clearInterval(visibleInterval)
    }
  },

  async mounted () {
    await this.startVisibleTimer()

    document.addEventListener('visibilitychange', this.handleVisibilityChange, false)
  },

  beforeDestroy () {
    this.stopVisibleTimer()
    document.removeEventListener('visibilitychange', this.handleVisibilityChange, false)
  }
}
